import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import { CheckboxLabeled } from '@ui/actions'
import { getShearAnchorsTemplateOptions } from 'src/domain/planTables/constants'
import type { PlanTableTemplateOptions } from 'src/domain/planTables/types'

interface Props {
  templateOptions: PlanTableTemplateOptions | undefined
  onChange: (templateOptions: PlanTableTemplateOptions) => void
}

const ShearAnchorsTemplateOptionsFields = ({ templateOptions, onChange }: Props): ReactElement => {
  const { showStoreyAnchorCount } = getShearAnchorsTemplateOptions(templateOptions)

  return (
    <Stack spacing={1} data-cy="plan-table-shear-anchors-options">
      <CheckboxLabeled
        checked={showStoreyAnchorCount}
        onChange={event =>
          onChange({ ...templateOptions, showStoreyAnchorCount: event.target.checked })
        }
        label="Anzahl im Geschoss anzeigen"
        data-cy="plan-table-show-shear-storey-anchor-count"
      />
    </Stack>
  )
}

export default ShearAnchorsTemplateOptionsFields
